import { render, staticRenderFns } from "./WidgetWelcome.vue?vue&type=template&id=0e49ff64"
import script from "./WidgetWelcome.vue?vue&type=script&lang=ts"
export * from "./WidgetWelcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports